import { render, staticRenderFns } from "./AdminAddUserSidebar.vue?vue&type=template&id=e9a35582&"
import script from "./AdminAddUserSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminAddUserSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAddUserSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports